import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TAGBIO extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAG BIO</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.3648 (E) Dated 13-08-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (12) Humalite 82% (Powder)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Humalite in natural form (Canada) per cent. by weight, minimum: 82</li>
                <li>(ii) Potassium hydroxide neutralizer per cent. by weight, minimum: 18</li>
                <li>(iii) Total (per cent): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Paddy</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>Paddy: Two applications (first as soil application at 7 days after transplantation at 1875 g/ha and second as foliar application on 28 days after transplantation at 312.5 g/ha)</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.3648 (ई) दिनांक 13-08-2025</li>
            <li><span className="label">2. बायोस्टिमुलेंट का नाम:</span> (12) ह्यूमालाइट 82% (पाउडर)</li>
            <li><span className="label">3. संरचना:</span>
              <ul>
                <li>(i) प्राकृतिक रूप में ह्यूमालाइट (कनाडा) भार के अनुसार प्रतिशत, न्यूनतम: 82</li>
                <li>(ii) पोटेशियम हाइड्रॉक्साइड न्यूट्रलाइज़र भार के अनुसार प्रतिशत, न्यूनतम: 18</li>
                <li>(iii) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> धान</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>धान: दो प्रयोग (पहला प्रयोग रोपाई के 7 दिन बाद मिट्टी में 1875 ग्राम/हेक्टेयर और दूसरा प्रयोग रोपाई के 28 दिन बाद पत्तियों पर 312.5 ग्राम/हेक्टेयर)</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> S.O.3648 (E) दिनांक १३-०८-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (१२) ह्युमलाइट ८२% (पावडर)</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) नैसर्गिक स्वरूपात ह्युमलाइट (कॅनडा) टक्के. वजनाने, किमान: ८२</li>
                <li>(ii) पोटॅशियम हायड्रॉक्साइड न्यूट्रलायझर टक्के. वजनाने, किमान: १८</li>
                <li>(iii) एकूण (टक्के): १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> भात</li>
            <li><span className="label">५. मात्रा:</span>
              <ul>
                <li>भात: दोन वेळा (प्रथम लागवडीनंतर ७ दिवसांनी मातीत मिसळून १८७५ ग्रॅम/हेक्टर आणि दुसरे लागवडीनंतर २८ दिवसांनी ३१२.५ ग्रॅम/हेक्टर दराने पानावर फवारणी करा)</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
